package com.karawek.core.ui.designcatalog.sections

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogHaptics() {
    Text(
        text = "Haptics",
        style = CoreTypography.title,
    )

    Text(
        text = "Haptic feedback is supported on iOS and Android.\n" +
                "Behavior is controlled globally and applied through CoreHaptics.",
        style = CoreTypography.bodySecondary,
    )
}
